(ns ycweb.app.website.registry.registry
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.registry.close]
   [ycweb.app.website.registry.collections]
   [ycweb.app.website.registry.create]
   [ycweb.app.website.registry.discountmanager]
   [ycweb.app.website.registry.edit]
   [ycweb.app.website.registry.guestpurchaselist]
   [ycweb.app.website.registry.modals]
   [ycweb.app.website.registry.search]
   [ycweb.app.website.registry.thankyoumanager]
   [ycweb.app.website.registry.view]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(def perks
  [{:public-id "pages/registry/landing/yuppiechef-wedding-registry-product-range"
    :alt "Yuppiechef Product Range"
    :heading "Wedding gifts that you and your guests will love"
    :body "Whether you're creating your starter home together, kitting out your kitchen or making your
    home an entertainer's dream, our range of over 8,900 quality kitchen and homeware products has wedding
    gifts you'll love and they'll love to give."}
   {:right? true
    :public-id "pages/registry/landing/yuppiechef-registry-setup"
    :alt "Yuppiechef wedding registry setup"
    :heading "It's free and easy to set up and share with friends and family"
    :body "Have fun personalising your wedding registry on your desktop, tablet or mobile. Add, remove
    and swap products anytime, and we'll track guest purchases for easy thank you's. What's more, we'll
    deliver your gifts to your door free whenever it's convenient after your big day."}
   {:public-id "pages/registry/landing/yuppiechef-registry-customer-support"
    :alt "Yuppiechef wedding registry customer support"
    :heading "You're in good hands"
    :body "We've been perfecting our registry service since 2010, and have delivered registries to over
    8,000 happy newlyweds throughout South Africa. We've also won a few awards along the way for it.
    And with our dedicated customer support team here to help you every step of the way, you're in good hands."}
   {:right? true
    :public-id "pages/registry/landing/yuppiechef-wedding-registry-perks"
    :alt "Yuppiechef wedding registry perks"
    :heading "Enjoy extra perks along the way"
    :body "Choose 3 lucky friends or family members to get a discount on their gift purchase. Plus we'll
    keep the celebration going with a post-wedding discount just for you, and a little something to
    celebrate your first anniversary!"}])

(defn perk [app-atom perk-count idx {:keys [public-id alt heading body right?] :as mark}]
  [:div
   {:class (yuc/bem :yc-section [(if (= perk-count (inc idx)) :medium-underline :medium)] (when (zero? idx) :u-margin-top-40))
    :key idx}
   [:article
    {:class (yuc/bem :callout-panel [(when right? :hero-right)])}
    [:div.flex-grid-group
     [:div
      {:class (yuc/bem :flex-grid-block [(when right? :m-order-02) :m-1-2])}
      [:div.flex-grid-content
       [:div.callout-panel__hero
        [:div.u-max-width-490
         (web-common/lazy-image app-atom
           public-id
           {:class ["yc-simple-image  yc-simple-image--full  yc-simple-image--shadow  yc-simple-image--border"]}
           {:w 486
            :q "auto"
            :alt alt})]]]]
     [:div
      {:class (yuc/bem :flex-grid-block [:m-1-2])}
      [:div.flex-grid-content
       [:div.callout-panel__content
        (headings/heading heading
          {:type :h2
           :size :medium})
        [:p.yc-paragraph body]]]]]]])

(def trust-symbols
  [{:image-src "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/quality-seals/quality-seal-personalised-service-light"
    :alt "Yuppiechef's Customer Service Team is here to help with your Wedding Registry"}
   {:image-src "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/quality-seals/quality-seal-years-trading-dark"
    :alt "Yuppiechef has stocked leading kitchen and homeware brands since 2006"}
   {:image-src "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1/pages/quality-seals/quality-seal-delivery-and-collection-light"
    :alt "Yuppiechef Wedding Registries are delivered to your door, free in RSA"}])

(defn trust-mark [idx {:keys [image-src alt] :as mark}]
  [:li.product-icons__item
   {:key idx}
   [:img
    {:src image-src
     :alt alt
     :class (yuc/bem :yc-simple-image [:center :full])}]])

;; Landing page
(rum/defc registry-landing < rum/reactive [app-atom]
  (web-common/set-meta-title! (str "Online Wedding Registry Service - Yuppiechef South Africa"))
  (let [user (cmn/curact app-atom [:user])]
    [:div
     [:div.header-banner.u-bg-peacock
      [:div.header-banner__text-wrapper
       [:div.header-banner__text.u-text-white
        [:h1.header-banner__title
         [:span.header-banner__pretitle "Yuppiechef"]
         " Wedding Registry"]]]
      [:div.header-banner__image-wrapper
       (web-common/lazy-image app-atom
         "pages/registry/landing/yuppiechef-wedding-registry-header-banner"
         {:class ["header-banner__image"]}
         {:w 960
          :mw 490
          :max-dpr 2
          :q "auto"
          :alt "Yuppiechef Wedding Registry"})]]
     [:div
      {:class (yuc/bem :yc-section [:medium-underline])}
      (headings/heading "Great gifts. Easy set-up. Free delivery."
        {:type :h2
         :size :medium
         :center true})
      [:div.u-block.u-block-center.u-max-width-720.u-text-center
       [:p
        {:class (yuc/bem :yc-paragraph [:medium-large])}
        "We're excited you're here! And we also know you've got a lot on your plate with planning a wedding,
        and you deserve one less thing to worry about. That's why creating and managing a Yuppiechef wedding
        registry is easy and convenient for everyone.  You can add gifts to your list from our full range of
        kitchen and home products, and we offer free delivery to your door after your big day. Easy. Peasy.
        Happily ever after."]]
      [:div.u-block.u-block-center.u-max-width-480
       [:div.flex-grid-group
        [:div
         {:class (yuc/bem :flex-grid-block [:s-1-2])}
         [:div.flex-grid-content
          (buttons/button-web "Find a registry"
            {:type :button
             :on-click #(grid/dispatch-action app-atom :web.registry/find-registry-modal {})
             :style :secondary
             :size :default
             :full true})]]
        [:div
         {:class (yuc/bem :flex-grid-block [:s-1-2])}
         [:div.flex-grid-content
          (cond
            user
            (buttons/button-web "Create your registry"
              (merge
                (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/create-registry-modal {}))
                {:type :button
                 :style :primary
                 :size :default
                 :full true}))

            :else
            (buttons/button-web "Create your registry"
              (merge
                (urlstate/href-props app-atom "registry" "create")
                {:type :button
                 :style :primary
                 :size :default
                 :full true})))]]]
       [:div.u-margin-top-20
        [:p.u-text-center
         {:class (yuc/bem :yc-paragraph [:flush])}
         "Buying a wedding gift? "
         [:b
          [:a.js-mfp-open-url
           {:href "/help.htm?action=article&id=43"
            :class (yuc/bem :text-link [:muted])
            :target_url
            "/help.htm?action=article&id=43&overrideincludes=blank"
            :data-title "Buying a gift from a wedding registry"
            :data-content-wrapper-class "yc-simple-text"}
           "Find out how it works."]]]]]]
     [:div
      {:class (yuc/bem :yc-section [:medium-underline])}
      [:aside.pinned-review
       [:div.u-block-center.u-max-width-80
        [:img.avatar.u-margin-bottom-20
         {:src
          "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1598530968/pages/registry/registry-testimonial-vanika-and-kritesh.jpg"
          :alt "Vanika and Kritesh"
          :class (yuc/bem :yc-simple-image [:shadow :border :full])}]]
       [:p.pinned-review__quote
        "As a loyal Yuppiechef customer it made perfect sense to me to have a gift registry with them.
        Easy to create, easy for guests to purchase and easy to get our gifts!"]
       [:small.pinned-review__author "— Vanika and Kritesh"]]]
     (headings/heading "Why choose Yuppiechef for your wedding registry?"
       {:type :h3
        :size :medium
        :center true})
     (map-indexed (partial perk app-atom (count perks)) perks)
     [:div
      {:class (yuc/bem :yc-section [:medium-underline])}
      [:aside.pinned-review
       [:div.u-block-center.u-max-width-80
        [:img.avatar.u-margin-bottom-20
         {:src
          "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/v1598531488/pages/registry/registry-testimonial-rizqah-and-allie.jpg",
          :alt "Rizqah and Allie"
          :class (yuc/bem :yc-simple-image [:shadow :border :full])}]]
       [:p.pinned-review__quote
        "We had so much fun putting our Yuppiechef wedding registry together — the process was painless
        and easy. The large variety of amazing products has resulted in our kitchen being fully kitted out!"]
       [:small.pinned-review__author "— Rizqah and Allie"]]]
     [:div
      {:class (yuc/bem :yc-section [:medium])}
      [:ul.group
       {:class (yuc/bem :product-icons [:center])}
       (map-indexed trust-mark trust-symbols)]]
     [:div
      {:class (yuc/bem :yc-section [:large])}
      [:div.cta-block.u-block-center.u-max-width-640.u-margin-top-20
       (headings/heading "Ready to get started?"
         {:type :h3
          :size :tiny
          :center true})
       [:p.yc-paragraph.u-text-center
        "Setting up a Yuppiechef online wedding registry is quick, easy and free."]
       [:div.u-block-center.u-max-width-320.u-text-center
        (cond
          user
          (buttons/button-web "Create your registry"
            (merge
              (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/create-registry-modal {}))
              {:type :button
               :style :primary
               :size :large
               :full true}))

          :else
          (buttons/button-web "Create your registry"
            (merge
              (urlstate/href-props app-atom "registry" "create")
              {:type :button
               :style :primary
               :size :large
               :full true})))]]]]))

(defmethod flow/render-screen :web.registry [app-atom _]
  (website/screen-wrapper app-atom
    (registry-landing app-atom)
    {:pagetype :registry}))

(defmethod grid/action :web.registry/create-registry-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/create-registry-modal
    {:config
     {:title "Create Registry"}}))
